export interface CallbackParams {
  token: string | null;
  refreshToken: string | null;
  userId: string | null;
}

function firstParam(url: URL, keys: string[]) {
  for (const key of keys) {
    const value = url.searchParams.get(key);
    if (value && value.trim().length > 0) return value;
  }
  return null;
}

export function parseCallbackParams(url: URL): CallbackParams {
  const values = Array.from(url.searchParams.values());
  return {
    token: firstParam(url, ["token", "access_token", "accessToken"]) ?? values[0] ?? null,
    refreshToken: firstParam(url, ["refreshToken", "refresh_token"]) ?? values[1] ?? null,
    userId: firstParam(url, ["idUser", "userId", "userID", "id_user"]) ?? values[2] ?? null,
  };
}

export function isCompleteCallback(params: CallbackParams): params is { token: string; refreshToken: string; userId: string } {
  return Boolean(params.token && params.refreshToken && params.userId);
}
